import { Icon } from "./Icon.tsx";

/** "Open .inp file" icon. */
export function FolderOpenIcon() {
  return (
    <Icon>
      <path d="M3 7a1 1 0 0 1 1-1h5l2 2h9a1 1 0 0 1 1 1v1H5" />
      <path d="M3 7v11a1 1 0 0 0 1 1h15a1 1 0 0 0 1-1V10a1 1 0 0 0-1-1H6a1 1 0 0 0-.96.73L3 17" />
    </Icon>
  );
}
